const sendEmail = (data = {}) => {
    // Setup the fetch options with the appropriate headers and body
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }

    const url = '/.netlify/functions/sendEmail-background'

    // Execute the POST request to the specified URL
    fetch(url, options)
}

export default sendEmail
